var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dna-container-mobile"},[_c('div',{directives:[{name:"in-viewport",rawName:"v-in-viewport",value:(_vm.log_one),expression:"log_one"}],attrs:{"id":"dna-animation-mobile"}})])}
var staticRenderFns = []

export { render, staticRenderFns }